import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import OrderConfirmation from "@/pages/OrderConfirmation";
import MyOrders from "@/pages/MyOrders";
import MyEnquiries from "@/pages/MyEnquiries";
import AdminLogin from "@/pages/AdminLogin";
import AdminHome from "@/pages/AdminHome";
import AdminSettings from "@/pages/AdminSettings";
import AdminProducts from "@/pages/AdminProducts";
import AdminProductEdit from "@/pages/AdminProductEdit";
import AdminOrders from "@/pages/AdminOrders";
import AdminOrderDetail from "@/pages/AdminOrderDetail";
import AdminDrivers from "@/pages/AdminDrivers";
import AdminInvoices from "@/pages/AdminInvoices";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminInquiries from "@/pages/AdminInquiries";
import AdminContacts from "@/pages/AdminContacts";
import TrackOrder from "@/pages/TrackOrder";
import PasswordResetRequest from "@/pages/PasswordResetRequest";
import PasswordResetConfirm from "@/pages/PasswordResetConfirm";
import RequireAuth from "@/pages/RequireAuth";
import CustomerLogin from "@/pages/CustomerLogin";
import AuthCallback from "@/pages/AuthCallback";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { Toaster } from "@/components/ui/sonner";

// Detect Google OAuth return (`#session_id=...`) synchronously during render
// so AuthCallback runs BEFORE any protected route mounts.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/catalog" element={<Catalog />} />
      <Route path="/product/:slug" element={<ProductDetail />} />
      <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
      <Route path="/my/orders" element={<MyOrders />} />
      <Route path="/my/enquiries" element={<MyEnquiries />} />
      <Route path="/customer/login" element={<CustomerLogin />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/password-reset" element={<PasswordResetRequest />} />
      <Route path="/admin/password-reset/confirm" element={<PasswordResetConfirm />} />
      <Route path="/admin" element={<RequireAuth><AdminHome /></RequireAuth>} />
      <Route path="/admin/settings" element={<RequireAuth><AdminSettings /></RequireAuth>} />
      <Route path="/admin/products" element={<RequireAuth><AdminProducts /></RequireAuth>} />
      <Route path="/admin/products/new" element={<RequireAuth><AdminProductEdit /></RequireAuth>} />
      <Route path="/admin/products/:id" element={<RequireAuth><AdminProductEdit /></RequireAuth>} />
      <Route path="/admin/orders" element={<RequireAuth><AdminOrders /></RequireAuth>} />
      <Route path="/admin/orders/:id" element={<RequireAuth><AdminOrderDetail /></RequireAuth>} />
      <Route path="/admin/drivers" element={<RequireAuth><AdminDrivers /></RequireAuth>} />
      <Route path="/admin/invoices" element={<RequireAuth><AdminInvoices /></RequireAuth>} />
      <Route path="/admin/customers" element={<RequireAuth><AdminCustomers /></RequireAuth>} />
      <Route path="/admin/inquiries" element={<RequireAuth><AdminInquiries /></RequireAuth>} />
      <Route path="/admin/contacts" element={<RequireAuth><AdminContacts /></RequireAuth>} />
      <Route path="/track" element={<TrackOrder />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CustomerAuthProvider>
          <AppRouter />
        </CustomerAuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
